import * as React from "react";
import { DashboardUsage, DashboardChartKeys } from "src/common";

type AllProps = {
    cx?: number;
    cy?: number;
    midAngle?: number;
    innerRadius?: number;
    outerRadius?: number;
    name?: string;
    value?: number;
    total?: number;
}
const RADIAN = Math.PI / 180;
function ChartLabelComponent(props: AllProps) {
    const { cx, cy, midAngle, outerRadius, name, value, total } = props;

    // NOTE: Pull labels slightly inside the arc to avoid container clipping
    const r_outer = Number(outerRadius ?? 0);
    const radius = Math.max(0, r_outer - 50);
    const cx_num = Number(cx ?? 0);
    const cy_num = Number(cy ?? 0);
    const mid = Number(midAngle ?? 0);
    const x = cx_num + radius * Math.cos(-mid * RADIAN);
    const y = cy_num + radius * Math.sin(-mid * RADIAN);
    const text_anchor = x > cx_num ? "start" : "end";

    // Description: Get percentage if name is DashboardChartKeys.used
    function getLabel() {
        return (value !== undefined) &&
            (!!total && name === DashboardChartKeys.used ? DashboardUsage.convertUsageToPercentUsed(value, total) :
                DashboardUsage.convertUsageToFriendlySize(value));
    }

    return <>
        {
            (!!value && value > 0) &&
            <g>
                <text className="recharts-slice-label" x={x} y={y} textAnchor={text_anchor} dominantBaseline="central">
                    {getLabel()}
                </text>

                <text className="recharts-slice-label-caption" x={x} y={y + 14} textAnchor={text_anchor} dominantBaseline="central">
                    {name}
                </text>
            </g>
        }
    </>;
}

export default React.memo(ChartLabelComponent);